import * as React from "react";
import { useTypedSelector } from "../state/store";
export default (function (_a) {
  var item = _a.item;
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languageLabels) {
    return React.createElement("div", null);
  }

  var unsupportedLabels = languageLabels.unsupported;
  return React.createElement("div", null, unsupportedLabels.notSupportedInsert(item.type));
});